import { render } from "./SectionContainer.vue?vue&type=template&id=49a4fdd1&scoped=true"
import script from "./SectionContainer.vue?vue&type=script&lang=js"
export * from "./SectionContainer.vue?vue&type=script&lang=js"

import "./SectionContainer.vue?vue&type=style&index=0&id=49a4fdd1&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a4fdd1"]])

export default __exports__